import { useQuery } from "@tanstack/react-query";
import { fetchVesselDataByTypeAndSizeApi } from "@/API/fetchVesselDataByTypeAndSizeApi";
import { VesselDTType } from "@/types/apiTypes";
import { ShowNotification } from "@/components/ShowNotification";
import { useLoadingContext } from "@/hooks/contextHooks/useLoadingContext";

export const useFetchVesselDataByTypeAndSize = (
  vesselType: string | undefined,
  vesselSize: string | undefined,
) => {
  const { startLoading, stopLoading } = useLoadingContext();

  return useQuery<VesselDTType, Error>({
    queryKey: ["vesselDataByTypeAndSize", vesselType, vesselSize],
    queryFn: async () => {
      if (!vesselType || !vesselSize) {
        ShowNotification({
          title: "Error",
          message: "Vessel type and size are required.",
          color: "error",
        });
        throw new Error("Vessel type or vessel size not provided");
      }

      startLoading();

      try {
        return await fetchVesselDataByTypeAndSizeApi(vesselType, vesselSize);
      } catch (error) {
        ShowNotification({
          title: "Error",
          message: "Failed to fetch vessel data.",
          color: "error",
        });
        throw error;
      } finally {
        stopLoading();
      }
    },
    enabled: Boolean(vesselType && vesselSize),
  });
};
